<div class="wrap">
    <div class="table flex column">
        <div class="row header flex align-centre">
            <div class="cell flex center">Zones</div>
            <div class="cell">Building typology</div>
        </div>
        <div class="row body flex" *ngFor="let zc of zoneCombinations; let i = index">
            <div class="cell flex center align-center row-name">{{zc.Name}}
                <calibration-set-attributes [identifiers]="zc.identifier" [attributePopupTitleDetails]="zc.Name">
                </calibration-set-attributes>
                <ziq-calibration-set-attributes-icons [attributesFlags]="zc" class="attributes-icons">
                </ziq-calibration-set-attributes-icons>
            </div>
            <div class="cell flex align-center between">
                <div class="box-wrap">
                    <input class="example-margin" type="checkbox" [id]="'box_' + i"
                        [(ngModel)]="zc.currentState.BuildingTypologyMandatory" (ngModelChange)="setValidation(i)"
                        [ngClass]="{ 'changed': checkChanges(buildingMandatoryField, i)}"><label [for]="'box_' + i">At
                        least one of the applicable Building Types is Mandatory</label>
                    <calibration-set-table-field-attributes [identifiers]="getMandatoryTableFieldIdentifier(zc.Id)"
                        [showPopover]="true"
                        [attributePopupTitleDetails]="zc.Name + ' - At least one of the applicable Building Types is Mandatory'">
                    </calibration-set-table-field-attributes>
                </div>
                <div class="select-wrap flex align-center" matTooltip="There aren't available Building Types"
                    [matTooltipDisabled]="isAvailable(i)" [matTooltipPosition]="'left'"
                    [ngClass]="{'default': !zc.BuildingTypologyData}">
                    <div class="active-part">
                        <mat-form-field style="margin: 5px 0px;" subscriptSizing="dynamic" [ngClass]="{
                                                'invalid': !zc.isValidBuildingTypology,
                                                'changed': zc.isFieldChanged(defaultBuildingTypology)
                                                }">
                            <mat-select [(ngModel)]="zc.currentState.DefaultBuildingTypology"
                                [placeholder]="zc.currentState.DefaultBuildingTypology == null ? 'None' : ''"
                                [required]="!zc.isValidBuildingTypology" [disabled]="!isAvailable(i)"
                                (ngModelChange)="setValidation(i)">
                                <mat-option *ngIf="!zc.currentState.BuildingTypologyMandatory" [value]="null">None
                                </mat-option>
                                <mat-option *ngFor="let buildTyp of zc.BuildingTypologyData" [value]="buildTyp.Id">
                                    {{buildTyp.Name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <calibration-set-table-field-attributes [identifiers]="getDefaultTableFieldIdentifier(zc.Id)"
                            [showPopover]="true" [attributePopupTitleDetails]="zc.Name + ' - Default Building Type'">
                        </calibration-set-table-field-attributes>
                    </div>
                    <div>
                        <span class="default-bld-type-lbl">Default Building Type</span><span *ngIf="zc.currentState.BuildingTypologyMandatory"
                            class="required-field" style="top:-5px;position:relative;">*</span><span *ngIf="!zc.currentState.BuildingTypologyMandatory"
                            class="required-field">&nbsp;&nbsp;</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
